import Agent, { compareVersion } from '../agent'
import { APP_NAME } from '../agent/typing'
import { toUrlParams } from '../base/url'
import { getStatisticUrl } from '../query'
import knbUse from '../knb/knb-use'

function getVersionByDevice(originVersion: string | { android: string; iphone: string }): string {
  if (typeof originVersion === 'string') {
    return originVersion
  } else if (Agent.android && originVersion.android) {
    return originVersion.android
  } else if (Agent.iphone && originVersion.iphone) {
    return originVersion.iphone
  }
  return ''
}

export interface I_RN_VERSIONS {
  phx: string
  meituan?: string
  dianping?: string
}

export interface I_RN_PARAMS {
  mrn_entry: string
  mrn_component: string
  mrn_translucent?: boolean
  mrn_skeleton?: string
  mrn_backup_url?: string
  params: Record<string, string | number | boolean | undefined>
  [x: string]: any
}

export function isSupportRN({ phx, meituan, dianping }: I_RN_VERSIONS): boolean {
  const version = Agent.version
  let comversion
  if (phx && Agent.phx) {
    comversion = getVersionByDevice(phx)
  } else if (meituan && Agent.meituan) {
    comversion = getVersionByDevice(meituan)
  } else if (dianping && Agent.dianping) {
    comversion = getVersionByDevice(dianping)
  }
  console.log(comversion)
  if (comversion && compareVersion(version, comversion) >= 0) {
    return true
  }
  return false
}

export function jump2RN({ mrn_entry, mrn_component, params }: I_RN_PARAMS): void {
  const map: Record<string, string> = {
    group: 'imeituan://www.meituan.com/mrn',
    phoenix: 'iaphx://iaphx.sankuai.com/mrn',
    dianping_nova: 'dianping://mrn',
  }
  const rnUrl =
    map[Agent.appnm || APP_NAME.group] +
    '?' +
    toUrlParams({ mrn_biz: 'zhenguo', mrn_entry, mrn_component }) +
    (params ? `&${toUrlParams(params)}` : '')
  knbUse('openPage', {
    url: getStatisticUrl(rnUrl),
    query: { _knbopeninapp: 1 },
  })
}
